// React
import React from 'react'

// Import spinner image
import swipelyticsSpinnerGIF from '../assets/swipelytics-spinner-4.gif'

// mui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'

// Standard spinner using logo GIF
export const standardSpinner = () => {
  // console.log('standardSpinner runs')
  return (
    <Box
      sx={{ 
        width: '100%', height: '100%', maxWidth: '100px',
        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
      }}
    >

      {/* GIF of present wrapping */}
      <Box component='img' src={swipelyticsSpinnerGIF} alt="Spinner" className="spinner" sx={{ maxWidth: 100 }} />

    </Box>  
  )
}

// Text Underneath spinner using logo GIF
export const textUnderneathStandardSpinner = (text = '', subText = '') => {
  // console.log('calculatingStandardSpinner runs')
  // console.log('preparing results ->', preparingResults)
  return (
    <Box
      sx={{ 
        width: '100%', height: '100%', maxWidth: '250px',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
      }}
    >

      {/* Spinner */}
      <Box
        sx={{
          width: '100%', maxWidth: '250px',
          height: '120px', minHeight: '120px',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Box component='img' src={swipelyticsSpinnerGIF} alt="Spinner" className="spinner" 
          sx={{ 
            maxWidth: 100,
          }} 
        />
      </Box>
      

      {/* Text */}
      {text.length > 0 &&
        <Box
          sx={{
            mt: 0,
            width: '100%',
            fontSize: '18px',
            fontFamily: 'Raleway',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              width: '100%',
              fontSize: '18px',
              fontFamily: 'Raleway',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {`${text}`}
          </Typography>
          
          {subText.length > 0 &&
            <Typography
              sx={{
                width: '100%',
                fontSize: '16px',
                fontFamily: 'Raleway',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {`${subText}`}
            </Typography>
          }
          
        </Box>
      }

    </Box>  
  )
}

// Circular Progress Spinner
export const circularSpinner = () => {
  return (
    <Box
      sx={{ 
        width: '100%', height: '100%',
        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
      }}
    >

      {/* circular spinner animation */}
      <CircularProgress color="primary" />

    </Box>  
  )
}